import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NwfSvg = function NwfSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CAD0E4",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E1C4E",
    fillRule: "evenodd",
    d: "M12.882 9.222 17 5.334v13.333h-3.53z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284285",
    fillRule: "evenodd",
    d: "m7 5.89 3.53-.556L17 15.889l-3.53 2.778z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C4486",
    fillRule: "evenodd",
    d: "m7 5.89 3.53-.556v13.333H7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262C67",
    fillRule: "evenodd",
    d: "m17 15.89-3.53 2.777-2.94-5.556z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212054",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "m7 18.666 10-7.5L7 5.89z",
    clipRule: "evenodd"
  }));
};
export var Nwf = function Nwf(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NwfSvg
  }));
};